export interface SpinnerDefaultProps {
  show?: boolean;
  fullscreen?: boolean;
  overlay?:boolean;
  message?: string;
  submessage?: string;
  large?: boolean; 
}

export function SpinnerDefault(props: SpinnerDefaultProps) {
  if (props.show != null && props.show === false)
    return <></>;

  if (props.overlay) {
    const spinnerSize = props.large ? 'spinner-border-lg' : '';
    
    return (
      <div 
        className="k-loading-mask position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center rounded"
        style={{ background: "rgba(255,255,255,0.9)" }}
      >
        <div className="text-center">
          <div className={`spinner-border text-primary mb-3 ${spinnerSize}`} role="status">
            <span className="visually-hidden">{props.message || "Loading..."}</span>
          </div>
          {props.message && <p className="fw-semibold text-muted mb-1">{props.message}</p>}
          {props.submessage && <p className="small text-muted mb-0">{props.submessage}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className={`spinner k-loading-mask w-100 d-flex justify-content-center my-3 ${props.fullscreen ? "fullscreen" : ""}`}>
      <div className="k-loading-image">
        <div className="k-loading-color"></div>
      </div>
      {props.message && <p className="ms-3 text-muted mb-0">{props.message}</p>}
    </div>
  );
}

export default SpinnerDefault;
